import React, { useEffect, useState } from "react";
import CustomSelectWithHookForm from "./custom-select-with-hook-form";
import {
  liveDemoFilterOptions,
  projectTypeFilterOptions,
} from "@/utils/constants";
import MultiRadioInput from "./MultiRadioInput";
import { Control, FieldErrors } from "react-hook-form";
import clientApi from "@/utils/clientApi";
import { useTranslations } from "next-intl";

interface TGlobalPageFilterSidebar {
  control: Control;
  errors: FieldErrors;
}

const GlobalPageFilterFields = ({
  control,
  errors,
}: TGlobalPageFilterSidebar) => {
  const [skillsOptions, setSkillsOptions] = useState([]);
  const [tracksOptions, setTracksOptions] = useState([]);
  const t = useTranslations();

  const fetchSkills = async () => {
    const response = await clientApi("/normal-skills?fields=techSkill,id");
    const formatSkills = response.data.data.skills.map(
      (skill: { techSkill: string }) => ({
        label: skill.techSkill,
        value: skill.techSkill.toLowerCase(),
      })
    );

    setSkillsOptions(formatSkills);
  };

  const fetchTracks = async () => {
    const response = await clientApi("/tracks?fields=track,id");
    const formatTracks = response.data.data.tracks.map(
      (skill: { track: string }) => ({
        label: skill.track,
        value: skill.track.toLowerCase(),
      })
    );

    setTracksOptions(formatTracks);
  };

  useEffect(() => {
    Promise.all([fetchSkills(), fetchTracks()]);
  }, []);

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium">{t("Filter by technology:")}</p>
        <CustomSelectWithHookForm
          control={control}
          errors={errors}
          fieldName="techs"
          options={skillsOptions}
          isMulti
        />
      </div>

      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium">{t("Filter by track:")}</p>
        <CustomSelectWithHookForm
          control={control}
          errors={errors}
          fieldName="projectRelated"
          options={tracksOptions}
        />
      </div>

      <MultiRadioInput
        label={t("Filter by project type")}
        control={control}
        options={projectTypeFilterOptions}
        name="projectType"
        errors={errors}
      />

      <MultiRadioInput
        label={t("Filter by live demo")}
        control={control}
        options={liveDemoFilterOptions}
        name="liveDemoLink"
        errors={errors}
      />
    </div>
  );
};

export default GlobalPageFilterFields;
